import { useQuery } from '@tanstack/react-query';
import { type DriveFile, extractDriveFolderId, getDriveFolderForRecord, listDriveFiles } from './drive';

export function driveFilesQueryKey(folderId: string | null | undefined, providerToken: string | null) {
  return ['docs-drive-files', folderId, providerToken?.slice(-12) ?? null] as const;
}

export function recordDriveFolderQueryOptions(tableName: string, recordId: number) {
  return {
    queryKey: ['docs-drive-folder', tableName, recordId] as const,
    queryFn: () => getDriveFolderForRecord(tableName, recordId),
  };
}

export function useRecordDriveFolder(tableName: string, recordId: number) {
  return useQuery<string | null>({
    ...recordDriveFolderQueryOptions(tableName, recordId),
    enabled: (tableName === 'merchant' || tableName === 'submission') && !!recordId,
  });
}

export function useMerchantDriveFolder(merchantId: number) {
  return useRecordDriveFolder('merchant', merchantId);
}

export function useDriveFiles(
  driveFolder: string | null | undefined,
  activeFolderId: string | null,
  providerToken: string | null,
) {
  const rootFolderId = extractDriveFolderId(driveFolder);
  const currentFolderId = activeFolderId ?? rootFolderId;

  const query = useQuery<DriveFile[]>({
    queryKey: driveFilesQueryKey(currentFolderId, providerToken),
    enabled: !!currentFolderId && !!providerToken,
    queryFn: () => listDriveFiles(currentFolderId as string, providerToken as string),
  });

  return { ...query, rootFolderId, currentFolderId };
}
